import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Chip,
  Button,
} from '@mui/material';
import { Person, Work, Edit } from '@mui/icons-material';
import { CaretakerProfile } from '../services/caretakerProfileService';

interface CaretakerBioProps {
  caretaker: CaretakerProfile;
  isOwner?: boolean;
  onEditBio?: () => void;
}

const CaretakerBio: React.FC<CaretakerBioProps> = ({ caretaker, isOwner = false, onEditBio }) => {
  console.log('🔍 CaretakerBio - Received caretaker:', caretaker);
  console.log('🔍 CaretakerBio - Bio:', caretaker.bio);
  console.log('🔍 CaretakerBio - Bio type:', typeof caretaker.bio);
  console.log('🔍 CaretakerBio - Bio length:', caretaker.bio?.length);
  
  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h5" component="h2" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Person />
            About {caretaker.firstName}
          </Typography>
          {isOwner && onEditBio && (
            <Button
              variant="outlined"
              startIcon={<Edit />}
              onClick={onEditBio}
              size="small"
            >
              Edit Bio
            </Button>
          )}
        </Box>
        
        {caretaker.bio ? (
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.7, mb: 3 }}>
            {caretaker.bio}
          </Typography>
        ) : (
          <Typography variant="body1" color="text.secondary" paragraph sx={{ mb: 3 }}>
            No bio available yet.
          </Typography>
        )}

        {/* Specialties */}
        {caretaker.specialties.length > 0 && (
          <Box>
            <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Work />
              Specialties
            </Typography>
            <Box display="flex" flexWrap="wrap" gap={1}>
              {caretaker.specialties.map((specialty) => (
                <Chip
                  key={specialty.id}
                  label={specialty.name}
                  color="primary"
                  variant="outlined"
                  sx={{ mb: 1 }}
                />
              ))}
            </Box>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default CaretakerBio;
